module.exports = __webpack_public_path__ + "assets/img/icon_word_game.d82d6136.png";